import * as envConfig from '../env-config';

const getHalterApiUrl = () => {
  const env: string = envConfig.environment;
  return (envConfig as any)[env].halterConfig.halter_api_url;
};

export default getHalterApiUrl;
